import { Injectable } from '@angular/core';
import { first, Subscription } from 'rxjs';
import { SignalUser } from '../../models/SignalUser/SignalUser';
import { SignalUserAPIService } from '../API/Signal-UserAPI.service';
import { NotificationsToastService } from '../Notifications-Toast.service';
import { AzureBotService } from "../../features/azure-bot/services/AzureBot.service";
@Injectable({
  providedIn: 'root'
})

export class SignalUserService {
 
  subscription_AddSignalUser: Subscription;
  subscription_DeleteSignalUser: Subscription;

  constructor(private signalUserService: SignalUserAPIService, 
    private notificationsToastService: NotificationsToastService,
    private AzureBotService: AzureBotService
  ) {
}

ngOnDestroy() {
   if (this.subscription_AddSignalUser)
    this.subscription_AddSignalUser.unsubscribe();
}


//subscribe al usuari de manera general a signal desde el login
SubscribeGeneralSignalUserService(SignalUser: SignalUser) {
  SignalUser.Identifier = "General";
  //Subscribe to SignalClient
  this.subscription_AddSignalUser = this.AddSignalUser(SignalUser)
  .pipe(first()).subscribe((data) => {
  })
}

SubscribeChatBotSignalUserService(SignalUser: SignalUser) {
  var user = localStorage.getItem("user");
  SignalUser.Identifier = "ChatBot-"+user;
  this.AzureBotService.signalIdentifier = SignalUser.Identifier;
  this.subscription_AddSignalUser = this.AddSignalUser(SignalUser)
  .pipe(first()).subscribe((data) => {
    console.log("SignalUserService: ", data);
    
  })
}

SubscribeIdentifierSignalUserService(SignalUser: SignalUser) {
  //Subscribe to SignalClient
  this.subscription_AddSignalUser = this.AddSignalUser(SignalUser)
  .pipe(first()).subscribe((data) => {
    this.notificationsToastService.showRealTime(
      "Activando Monitoreo con Satelites en Tiempo Real",
      "LiveUpdate Activado"
    );
  })
}

UnsubscribeSignalUserService(){
//Subscribe to SignalClient
  this.subscription_DeleteSignalUser = this.DeleteByUser()
  .subscribe((data) => {
  });
}

UnsubscribeSignalUserIdentifierService(identifier : string){
  //Subscribe to SignalClient
  this.subscription_DeleteSignalUser = this.DeleteByUserIdentifier(identifier)
  .subscribe((data) => {
    this.notificationsToastService.showDisconnectRealTime(
      "LiveUpdate Desactivado",
      "LiveUpdate Desconectado"
    )
  });
  }

private AddSignalUser(signalUser: SignalUser): any {
  return this.signalUserService.AddSignalUser(signalUser);
}

DeleteByUser() {
  return this.signalUserService.DeleteByUser();
}
private DeleteByUserIdentifier(identifier: string) {
  return this.signalUserService.DeleteByUserIdentifier(identifier);
}
}
